import { useCallback, useEffect, useRef, useState } from 'react';

import { getLoopBrowserStatus } from '../../services/extensionBridge';
import type { LoopBrowserStatus } from '../../services/extensionBridge';

export function useLoopBrowserExtension() {
  const [extension, setExtension] = useState<LoopBrowserStatus | null>(null);
  const [checking, setChecking] = useState(true);
  const revision = useRef(0);
  const refreshExtension = useCallback(async () => {
    const current = ++revision.current;
    const status = await getLoopBrowserStatus();

    if (current === revision.current) { setExtension(status); setChecking(false); }

    return status;
  }, []);

  useEffect(() => {
    const refresh = () => { void refreshExtension(); };

    refresh();
    window.addEventListener('focus', refresh);
    // Pairing returns before the extension's socket authenticates. Keep this visible panel up to date.
    const timer = window.setInterval(() => { if (!document.hidden) refresh(); }, 5000);

    return () => {
      revision.current += 1;
      window.clearInterval(timer);
      window.removeEventListener('focus', refresh);
    };
  }, [refreshExtension]);

  return { extension, checking, refreshExtension };
}
